import { Country } from './enum/country.enum';

export enum CloudScheduleParameters {
    MANUAL = 'MANUAL',
    SUNCAST = 'SUNCAST',
    SUNCAST_WITH_PRICES = 'SUNCAST_WITH_PRICES',
}

export interface Client {
    id: string;
    lastName: string;
    firstName: string;
    email: string;
    adresse: string | null;
    kwhRate: number;
    country: Country;
    hasGridStreamMeter: boolean;
    hasErl: boolean;
    hasStorageBattery: boolean;
    ratingPrompt: boolean;
    onboardingDone?: boolean;
    forcedOnAcknowledged?: boolean;
    installPower: number | null;
    staticThreshold: number | null;
    dynamicThreshold: number | null;
    annualConsumption: number | null;
    monthlyConsumptionCost: number | null;
    baseConsumptionLevel: number | null;
    cloudScheduleParameter: CloudScheduleParameters | null;
}
